// staging server API

export const API_URL = "https://api.hedr.cloud/";

// local server API
// export const API_URL = "http://192.168.1.29:8057/";
// export const API_URL = "http://192.168.1.15:8056/";

export const FILE_URL = `${API_URL}assets/`